<script lang="ts">
import { defineComponent } from 'vue';
import { getIconAlias } from '@/utils/transform';
import IconSports from '@/helpers/icon-pack-sports.vue';
import { useFavoritesStore } from '@/stores/favorites';
import { mapActions, mapState } from 'pinia';
import { formatDate } from '@/utils/format';

export default defineComponent({
  name: 'popular-competitions',
  components: { IconSports },
  computed: {
    ...mapState(useFavoritesStore, ['popularCompetitionsLoading']),
  },
  methods: {
    ...mapActions(useFavoritesStore, ['deletePopularCompetition']),
    getIconAlias,
    formatDate,
  },
  props: ['competitions'],
});
</script>

<template>
  <section class="relative mx-3">
    <div v-if="popularCompetitionsLoading" class="table-loader">
      <i class="pi pi-spinner animate-spin text-gray-200" style="font-size: 5em" />
    </div>
    <table class="basic-table">
      <thead>
        <tr>
          <th style="width: 80px">ID</th>
          <th style="width: 100px; text-align: left">Спорт</th>
          <th style="text-align: left">Турнир</th>
          <th style="width: 120px">Первый</th>
          <th style="width: 120px">Последний</th>
          <th style="width: 80px">Матчей</th>
          <th style="width: 80px">Действия</th>
        </tr>
      </thead>
      <tbody>
        <template v-for="competition in competitions" v-key="competition.Id">
          <tr>
            <td>{{ competition.competition_id }}</td>
            <td>
              <div class="flex gap-1 flex-wrap">
                <IconSports
                  v-for="sport_id in competition.sport_ids"
                  v-key="sport_id"
                  cssClass="fill-gray-600 dark:fill-white"
                  :id="getIconAlias(sport_id)"
                  :height="20"
                  :width="20"
                />
              </div>
            </td>
            <td style="text-align: left">{{ competition.competition_name }}</td>
            <td>
              {{ formatDate(competition.first_time_utc, 'DD.MM.YYYY') }}
              <span class="text-gray-500">{{
                formatDate(competition.first_time_utc, 'HH:mm')
              }}</span>
            </td>
            <td>
              {{ formatDate(competition.last_time_utc, 'DD.MM.YYYY') }}
              <span class="text-gray-500">{{
                formatDate(competition.last_time_utc, 'HH:mm')
              }}</span>
            </td>
            <td>{{ competition.fixtures_count }}</td>
            <td>
              <div
                class="cursor-pointer"
                title="Удалить"
                @click="deletePopularCompetition(competition.competition_id)"
              >
                <i class="pi pi-times text-red-500"></i>
              </div>
            </td>
          </tr>
        </template>
      </tbody>
    </table>
  </section>
</template>

<style scoped lang="scss"></style>
